// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ManualIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ManualIcon" ref={forwardedRef} {...props}>
      <path d="M5.361 7.497a1 1 0 0 0-1.475-.015L2.597 8.86a1 1 0 0 0-.043 1.316L6.5 15l9.5-.018v-9.66a1 1 0 0 0-.492-.862l-3.935-2.321A1 1 0 0 0 11.064 2L7.5 1.999a1 1 0 0 0-1 1l.113 5.896zm9.139 5.985L7 13.5l-3.433-4 1.065-1.042 2.534 2.792H8V3.499h3l3.5 1.883z" />
      <path d="M16 17.983H6.5v-1.498H16z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ManualIcon = /* @__PURE__ */ Object.assign(ManualIconComponent, {
  displayName: 'ManualIcon',
});
